import { selectDeliveryReturnsItem, extractTeaserData } from '../utils/eipContentSelector';

export const getDeliveryAndReturnsLegalInfo = (state, isEip) => {
    const deliveryReturnsContent = state?.pdp?.deliveryReturnsContentState?.response?.body?.content?.[0] || {};
    const items = deliveryReturnsContent.items || [];

    const selectedItem = selectDeliveryReturnsItem(items, isEip);
    const teaserData = extractTeaserData(selectedItem);

    return {
        ...teaserData,
        loading: state.pdp?.deliveryReturnsContentState?.loading || false,
        error: state.pdp?.deliveryReturnsContentState?.error || false,
    };
};
